import { useEffect } from 'react';
import Animated, {
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from 'react-native-reanimated';
import { Stack } from '@/common/components/Stack/Stack';
import { TColors } from '@coverflex-tech/hypernova-design-tokens';
import { styles } from './ProgressBar.styles';

export interface IProgressBarsProps {
  bars: IProgressBar[];
  className?: string;
  backgroundColor?: keyof TColors['light']['semantic']['surface'];
  direction?: 'normal' | 'reverse';
}

export interface IProgressBar {
  percentage: number;
  backgroundColor?: keyof TColors['light']['semantic']['surface'];
  direction?: 'normal' | 'reverse';
}

export const ProgressBar = ({
  bars,
  className,
  backgroundColor,
  direction = 'normal',
}: IProgressBarsProps) => {
  return (
    <Stack className={styles.root({ backgroundColor, className })}>
      {bars.map(
        (bar, index) =>
          bar.percentage > 0 &&
          bar.percentage <= 100 && (
            <Bar
              key={index}
              percentage={bar.percentage}
              backgroundColor={bar.backgroundColor}
              direction={direction}
            />
          )
      )}
    </Stack>
  );
};

function Bar({
  percentage,
  backgroundColor,
  direction = 'normal',
}: IProgressBar) {
  const width = useSharedValue(direction === 'reverse' ? '100%' : '0%');

  useEffect(() => {
    width.value = direction === 'reverse' ? `${percentage}%` : '100%';
  }, [percentage, width, direction]);

  const animatedStyle = useAnimatedStyle(() => ({
    width: withTiming(width.value),
  }));

  return (
    <Animated.View
      className={styles.bar({ backgroundColor })}
      style={animatedStyle}
    />
  );
}
